// AI: justified because the generated client (`@app/api-client/generated`) is not
// available until `pnpm api:generate` has been run at least once. After the first
// generation, this file MUST be deleted and the generated hooks used instead.

import { apiAxios } from '@app/api-client';
import type {
  AdminCreateUserInput,
  AdminUserListQuery,
  GeneralRulesDto,
  MyWorkSiteDto,
  Pagination,
  UpdateGeneralRulesInput,
  UpdateUserRoleInput,
  UserDto,
} from '@app/contracts';

/** Première page avec la limite max autorisée par `paginationQuerySchema` (actuellement 100). */
export const ADMIN_USERS_LIST_MAX_PAGE = { page: 1, limit: 100 } as const satisfies Pick<
  AdminUserListQuery,
  'page' | 'limit'
>;

export interface PaginatedUsers {
  data: UserDto[];
  pagination: Pagination;
}

export const fetchAdminUsers = (params: AdminUserListQuery) =>
  apiAxios<PaginatedUsers>({ url: '/api/v1/admin/users', method: 'GET', params });

export const createAdminUser = (input: AdminCreateUserInput) =>
  apiAxios<UserDto>({ url: '/api/v1/admin/users', method: 'POST', data: input });

export const updateUserRole = (id: string, input: UpdateUserRoleInput) =>
  apiAxios<UserDto>({ url: `/api/v1/admin/users/${id}/role`, method: 'PATCH', data: input });

export const disableUser = (id: string) =>
  apiAxios<UserDto>({ url: `/api/v1/admin/users/${id}/disable`, method: 'POST' });

export const enableUser = (id: string) =>
  apiAxios<UserDto>({ url: `/api/v1/admin/users/${id}/enable`, method: 'POST' });

export const fetchUserGeneralRules = (userId: string) =>
  apiAxios<GeneralRulesDto>({ url: `/api/v1/users/${userId}/general-rules`, method: 'GET' });

export const updateUserGeneralRules = (userId: string, input: UpdateGeneralRulesInput) =>
  apiAxios<GeneralRulesDto>({
    url: `/api/v1/users/${userId}/general-rules`,
    method: 'PATCH',
    data: input,
  });

export const fetchUserSites = (userId: string) =>
  apiAxios<MyWorkSiteDto[]>({ url: `/api/v1/users/${userId}/sites`, method: 'GET' });

export const assignUserToSite = (userId: string, siteId: string, isPreferred = false) =>
  apiAxios<{ ok: true }>({
    url: `/api/v1/users/${userId}/sites`,
    method: 'POST',
    data: { siteId, isPreferred },
  });

export const unassignUserFromSite = (userId: string, siteId: string) =>
  apiAxios<void>({ url: `/api/v1/users/${userId}/sites/${siteId}`, method: 'DELETE' });

export const setPreferredSiteForUser = (userId: string, siteId: string) =>
  apiAxios<{ ok: true }>({
    url: `/api/v1/users/${userId}/preferred-site`,
    method: 'PATCH',
    data: { siteId },
  });
